const API = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "kg_admin_token";

export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => sessionStorage.removeItem(TOKEN_KEY);

function formatDetail(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return "Something went wrong. Please try again.";
}

export async function adminLogin(password) {
  const res = await fetch(`${API}/api/admin/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ password }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(formatDetail(data.detail));
  setToken(data.token);
  return data;
}

export async function adminGet(path) {
  const res = await fetch(`${API}/api/admin${path}`, { headers: { Authorization: `Bearer ${getToken()}` } });
  if (res.status === 401) {
    clearToken();
    throw new Error("unauthorized");
  }
  if (!res.ok) throw new Error("Request failed");
  return res.json();
}

export async function adminPost(path, body) {
  const res = await fetch(`${API}/api/admin${path}`, {
    method: "POST", headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "application/json" }, body: JSON.stringify(body),
  });
  if (res.status === 401) { clearToken(); throw new Error("unauthorized"); }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(formatDetail(data.detail));
  return data;
}

export async function adminDownload(kind) {
  const res = await fetch(`${API}/api/admin/export/${kind}`, { headers: { Authorization: `Bearer ${getToken()}` } });
  if (!res.ok) throw new Error("Export failed");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `kensgold-${kind}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

export const money = (cents) => `$${((cents || 0) / 100).toFixed(2)}`;
export const when = (iso) => (iso ? new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }) : "—");
